import { PropsWithChildren, ReactElement } from "react";
import styles from "./AnalyticsShortList.module.less";
import { Anchor, TextSkeleton } from "client/Components";
import { StatisticsFormatter, useStatisticsFormatters } from "./common";
import { isNotNil } from "client/Misc/utils";
import classNames from "classnames";

export const AnalyticsShortList = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<ol className={styles.root}>
			{children}
		</ol>
	);
};
AnalyticsShortList.displayName = "AnalyticsShortList";

export type AnalyticsShortListItemProps =
| {
	isLoading: true;
}
| {
	isLoading?: false;
	name: string;
	onClick?: () => void;
	isDisabled?: boolean;
	value: number;
};

const Item = (props: AnalyticsShortListItemProps): ReactElement => {
	const formatter: StatisticsFormatter = useStatisticsFormatters();

	const renderContent = (): ReactElement => {
		if (props.isLoading) {
			return <TextSkeleton />;
		}

		const {
			name,
			value,
			onClick
		} = props;

		return (
			<>
				{isNotNil(onClick)
					? (
						<Anchor
							className={classNames(
								styles.title,
								styles.title_clickable
							)}
							onClick={() => onClick()}
						>
							{name}
						</Anchor>
					)
					: (
						<span className={styles.title}>
							{name}
						</span>
					)
				}
				<span
					className={styles.counter}
					title={formatter(value, true)}
				>
					{formatter(value)}
				</span>
			</>
		);
	};

	return (
		<li
			className={classNames(
				styles.item,
				{[styles.item_disabled]: !props.isLoading && props.isDisabled}
			)}
		>
			{renderContent()}
		</li>
	);
};
Item.displayName = "AnalyticsShortList.Item";

AnalyticsShortList.Item = Item;